module.exports = __webpack_public_path__ + "static/Communication-5fc7f9724b04c0e40c5039bf9a0d3696.png";